export default "__VITE_ASSET__BIz030Sn__"